import './Select.css'
import Select, { NonceProvider } from 'react-select'
import { useTranslation } from 'react-i18next'

export default function MySelect(props) {
	const { t } = useTranslation()

	const customStyles = {
		dropdownIndicator: base => ({
			...base,
			color: '#7E7D7D'
		}),
		indicatorSeparator: base => ({
			...base,
			display: 'none'
		}),
		valueContainer: base => ({
			...base,
			height: 6.5 + 'vh',
		}),
		control: (base, { isFocused }) => ({
			...base,
			height: 60 + 'px',
			border:  isFocused ? '1px solid #367BCF' : props?.err ? '1px solid #F20505' : '1px solid #CCCCCC',
			boxShadow: 'none',
			borderRadius: '9px',
			'&:hover': {
				border: '1px solid #367BCF',
			}
		}),
		singleValue: base => ({
			...base,
			fontSize: '17px',
		}),
		option: (base, { isSelected }) => ({
			...base,
			fontSize: '18px',
			padding: '15px 10px'
		})
	}

	const handleMenuOpen = () => {
		if (props.onClick) {
			props.onClick()
		}
	}

	const noOptionsMessage = () => {
		return t('No options')
	}

	return (
		<Select
			styles={customStyles}
			options={props?.options}
			theme={(theme) => ({
				...theme,
				borderRadius: 6,
				colors: {
					...theme.colors,
					primary: '#4694D9'
				},
			})}
			defaultValue={[{value: ''}]}
			value={props?.defaultValue}
			onChange={props?.onChange}
			onMenuOpen={handleMenuOpen}
			isSearchable={false}
			required={props?.required}
			noOptionsMessage={noOptionsMessage}
		/>
	)
}